module.exports = __webpack_public_path__ + "static/media/revrogers.2652cddc.PNG";